import script from "./CompanyDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyDetails.vue?vue&type=script&setup=true&lang=ts"

import "./CompanyDetails.vue?vue&type=style&index=0&id=2efa0dc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2efa0dc6"]])

export default __exports__